<div class="options" *ngIf="stateTranslateService.onLoadedLocalizationData | async">
  <div class="options__wrapper">
    <div class="options__content">


      <div
        #scrollElement
        class="options__tabs-wrapper position-relative h-scrollbar h-scrollbar--hidden"
        (scroll)="onScroll()"
    > 

    <div
       class="options__arrow options__arrow-prev"
      (click)="scrollLeft()"
      *ngIf="!visibility.firstCategory"
  >
     <img src="/assets/caret-left.svg" alt="caret" />
   </div>
  <div
    class="options__arrow options__arrow-next"
    (click)="scrollRight()"
    *ngIf="!visibility.lastCategory"
  >
    <img src="/assets/caret-left.svg" alt="caret" />
  </div>

    <atl-simple-tabs 
       class="iframe-tabs" 
       [exact]="false" 
       [activeTab]="activeTab" 
       [tabs]="navMenu"
       [skipTranslation]="true" 
       [truncateLimit]="truncateLimit"
       [showTooltip]="true"
       [listenVisibility]="true"
       (visibilityEvent)="setArrowsVisibility($event)"
       (selectingTab)="onCategorySelect()"></atl-simple-tabs>
      </div>

      <div class="options__summary cursor-pointer" (click)="openSummary()"
      [ngClass]="{
        'options__summary--active': isSummaryPage,
        'disabled-summary': disabledSummary
      }">
        <div class="options__summary__wraper">
          <img src="/assets/cart-new-icon.svg" alt="Purchase icon" [class.basket-icon--active]="isSummaryPage"
            class="basket-icon mr-8" />
          <span *ngIf="showPrices" class="ellipsis options__summary__price fw-500">
            {{ totalPrice | customDecimal: 0 }},-
          </span>

        </div>
      </div>

      <div class="options__summary--share" (click)="openShareModal()">
          <img src="/assets/download-frame.svg" alt="Icon">
      </div>

      <div class="options__summary--download" (click)="openDownloadModal()">
        <img src="/assets/share-frame.svg" alt="Icon">
    </div>
      <router-outlet> </router-outlet>
    </div>
  </div>
</div>